import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Wrapper } from './styled'

export const Maintenance = () => {
  return (
    <Wrapper>
      <span>
        <FormattedMessage
          id='app.maintenance'
          values={{
            appName: process.env.REACT_APP_TITLE,
            br: <br />
          }}
        />
      </span>
    </Wrapper>
  )
}
